module.exports = __webpack_public_path__ + "static/media/valentina_guerrero_marin_10.b1f36865.jpg";